export enum AgreementLink {
  TermsAndConditions = 'https://higosense.com/terms-of-use-and-privacy-policy/#terms',
  PrivacyPolicy = 'https://higosense.com/terms-of-use-and-privacy-policy',
}
